export const INVENTORIZE_EXTRACTION_PATHS = {
  accessibility: 'accessibility',
  calibrated: 'calibrated',
  manufactured: 'manufactured',
  manufacturer: 'manufacturer',
  meterModel: 'meterModel',
  meterMountTechnology: 'meter_mount_technology',
  meterMountType: 'meter_mount_type',
  remoteReadingOwner: 'remote_reading_owner',
  remoteReadingSerial: 'remote_reading_serial',
  serial: 'serial',
} as const;

export const INVENTORIZE_REGISTER_EXTRACTION_PATH_KEYS = {
  label: 'name',
  obis: 'obis',
  tariff: 'tariff',
  unit: 'unit',
  value: 'reading_counter',
} as const;

export type InventorizeRegisterExtractionPathKey =
  (typeof INVENTORIZE_REGISTER_EXTRACTION_PATH_KEYS)[keyof typeof INVENTORIZE_REGISTER_EXTRACTION_PATH_KEYS];

export function createInventorizeRegisterExtractionPath(index: number, key: InventorizeRegisterExtractionPathKey) {
  return `registers.${index}.${key}`;
}

export function createInventorizeDetailExtractionPath(key: string) {
  return `detail.${key}`;
}
